export const deprecated =
  'DEPRECATION WARNING - this api will not be available in edocat base 4.0, visit https://bitbucket.onlio.com/projects/EB/repos/edocatbase/browse/BaseShare/src/react/global?at=refs%2Fheads%2F3.2.X-DEV for details';
